import { render, staticRenderFns } from "./XoImg.vue?vue&type=template&id=624a4e24&"
import script from "./XoImg.vue?vue&type=script&lang=js&"
export * from "./XoImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports